const checklist = {
	module: "Sjekklister",
	properties: "Egenskaper",
	forms: "Skjemaer",
	create_checklist: "Legg til sjekkliste",
	id: "ID",
};
export default checklist;